import React from 'react';
import {Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton,AccordionItemPanel} from 'react-accessible-accordion';
import OpenJobStyle from '@/styles/components/careers/open-jobs/_index.module.scss';
import { useTranslation, Button, Form, Formik, Checkbox, Select,useEffect, useState, FormikControl, InputError, ShowJobAction, INITIAL_VALUES } from '@/imports-files/pages/career/customize-career-page';
import SearchIcon from 'public/icons/career_icons/search.svg';
import SearchClose from 'public/icons/career_icons/search-close.svg';

export function OpenJobs({job_data, page_section, customizeCareerAction, formik, isPreview, isPublic, isFrame})
{
  const { t, i18n } = useTranslation();
  const showJobAction =  new ShowJobAction();
  const [data, setPropsData]                      =  useState(job_data);
  const [searching, searchValues]                 =  useState(INITIAL_VALUES);
  const [jobOptions, setJobOptions] =  useState(isPreview ? {options: [{label: t('placeholder:select:please'), value: ''}, {label: t('jobs:details:employment_type:full_time'), value: 'full_time'}, {label: t('jobs:details:employment_type:part_time'), value: 'part_time'}, {label: t('jobs:details:employment_type:either'), value: 'either'}]} : {options: []});
  const [locationOptions, setLocationOptions]     =  useState(showJobAction.get_json_data_for_locationOption(data.job_locations || [], data.job_countries || []));
  const [remoteOnlyOptions, setRemoteOnlyOptions] = useState(isPreview ? {options: [{label:  t('placeholder:select:please'), value: ''}, {label: t('jobs:details:locations:all'), value: 'all'}, {label: t('jobs:details:locations:on_site'), value: 'on_site'}, {label: t('jobs:details:locations:is_remote'), value: 'is_remote'}, {label: t('jobs:details:locations:is_hybrid'), value: 'is_hybrid'}]} : {options: []});
  const [filterOptions, setFilterOptions] = useState({job_type: '', job_location: ''});
  const labelStyle = customizeCareerAction.labelStyle(formik)
  const bodyStyle = customizeCareerAction.bodyStyle(formik)
  const headingFontColor = customizeCareerAction.job_benefit_heading_color(formik)
  const [mFilterText, setMFilterText] = useState("Show filters")
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    setRemoteOnlyOptions(
      isPreview
        ? {
            options: [
              { label: t('placeholder:select:please'), value: '' },
              { label: t('career:jobs:all'), value: 'all' },
              { label: t('career:jobs:on_site'), value: 'on_site' },
              { label: t('career:jobs:remote'), value: 'is_remote' },
              { label: t('career:jobs:hybrid'), value: 'is_hybrid' },
            ],
          }
        : { options: [] }
    );
    setJobOptions(
      isPreview
      ? {
        options: [
          {label: t('placeholder:select:please'), value: ''},
          {label: t('jobs:details:employment_type:full_time'), value: 'full_time'},
          {label: t('jobs:details:employment_type:part_time'), value: 'part_time'},
          {label: t('jobs:details:employment_type:either'), value: 'either'}
        ],
      }
      : { options: [] }

    )
  }, [isPreview, t]);
  return(
    <div className = {`${OpenJobStyle.Jobs}`} id={page_section.uniq_reference}>
        <div className = {`${OpenJobStyle.Jobs__Title}`}>
          <h1 style={headingFontColor}>
          {t('career:jobs:title')}
          </h1>
        </div>
        <div className = {`OpenJobs ${OpenJobStyle.Jobs__Container}`}>
            <div className = {`${OpenJobStyle.Jobs__JobFilter}`}>
            <div className={OpenJobStyle.Jobs__SearchInputWidth}>
            {/* Search Input */}
              <div className={OpenJobStyle.Jobs__SearchInput}>
                  <div className={`${OpenJobStyle.Jobs__SearchInput__InputField}`}>
                    <input
                        type="text"
                        placeholder={t('placeholder:search:role_ui_designer')}
                        className={OpenJobStyle.Jobs__SearchInput__Input}
                        name ="search"
                        value={searchText}
                        disabled={!isPreview}
                        onChange={(event) => {
                          setSearchText(event.target.value)
                          showJobAction.handleValueOnChange('search_text', event.target.value, searching, searchValues, setPropsData, data, isFrame)
                        }}
                      />
                      <div className={`${OpenJobStyle.Jobs__Searchbtn}`}>
                        <Button type="button"
                          onClick={() => {
                            setSearchText("")
                            showJobAction.handleValueOnChange('search_text', "", searching, searchValues, setPropsData, data, isFrame)
                          }}
                          style={isPreview ? {} : {background: "rgb(242 242 242)", cursor: "no-drop" } }
                        >
                        {searchText.length > 0 ? <SearchClose/> : <SearchIcon />}
                        </Button>
                      </div>
                  </div>
              </div>
               </div>
              {/* End of Search Input */}
            <div className = {`${OpenJobStyle.Jobs__AccordionInMobile} Accordian__Filter`}>
              <Accordion onChange={()=> {
                  mFilterText == "Show filters" ? setMFilterText("Hide filters") : setMFilterText("Show filters")
                }} allowZeroExpanded>
                <AccordionItem>
                  <AccordionItemPanel>
                     <Formik>
                {(formik) => (
                  <div className={OpenJobStyle.Jobs__Width100}>
                    <div className={OpenJobStyle.Jobs__Select}>
                      {/* Job location */}
                        <div className={`${OpenJobStyle.Jobs__Location}`}>
                          {/* <Select className={`${OpenJobStyle.Jobs__CustomSelect}`} options={job_locations || []} /> */}
                          <FormikControl
                            className       =     {`${OpenJobStyle.Jobs__Location}`}
                            placeholder     =     "Location"
                            control         =     "select"
                            default         =     {searching.location_text || ''}
                            formik          =     {formik}
                            disabled        =     {!isPreview}
                            isClearable     =     {true}
                            onChange        =     {(value) => showJobAction.handleValueOnChange('location_text', value, searching, searchValues, setPropsData, data, isFrame)}
                            options         =     {locationOptions.options}
                          />
                        </div>
                        {/* End of Job Location */}

                        {/* Job Type Input */}
                      <div className={OpenJobStyle.Jobs__JobType}>
                          {/* <Select className ={`${OpenJobStyle.Jobs__CustomSelect}`} options={job_types || []} /> */}
                          <FormikControl
                            className       =     {`${OpenJobStyle.Jobs__CustomSelect}`}
                            control         =     "select"
                            placeholder     =     {t('placeholder:job_type')}
                            //default         =     {searching.job_type || ''}
                            default         =      {jobOptions.options[1]}
                            formik          =     {formik}
                            disabled        =     {!isPreview}
                            isClearable     =     {true}
                            onChange        =     {(value) => showJobAction.handleValueOnChange( 'job_type', value, searching, searchValues, setPropsData, data, isFrame)}
                            options         =     {jobOptions.options}
                          />
                      </div>
                      {/* End of Job Type Input */}

                        {/* Job Remote */}
                        <div className={`${OpenJobStyle.Jobs__Remote}`}>
                          {/* <Select className={``} */}
                          {/*   options={remoteOnlyOptions.options} */}
                          {/*   onChange    =   {(event) => showJobAction.handleValueOnChange( 'remote', event.target.checked, searching, searchValues, setPropsData, data)} */}
                          {/* /> */}
                          <FormikControl
                            className       =     {`${OpenJobStyle.Jobs__CustomSelect}`}
                            control         =     "select"
                            placeholder     =     {"Remote"}
                            default         =     {remoteOnlyOptions.options[1]}
                            formik          =     {formik}
                            disabled        =     {!isPreview}
                            isClearable     =     {true}
                            onChange        =     {(option) => showJobAction.handleValueOnChange('remote', option.value, searching, searchValues, setPropsData, data, isFrame)}
                            options         =     {remoteOnlyOptions.options}
                          />
                        </div>
                        {/* End of Job Remote */}

                      </div>
                  </div>
                )}
              </Formik>
                  </AccordionItemPanel>
                  <AccordionItemHeading>
                      <AccordionItemButton>
                         {mFilterText}
                      </AccordionItemButton>
                  </AccordionItemHeading>
              </AccordionItem>
            </Accordion>
          </div>
          <div className = {`${OpenJobStyle.Jobs__HideInMobile} w100`}>
              <Formik>
              {(formik) => (
                <div className={OpenJobStyle.Jobs__Width100}>
                  <div className={OpenJobStyle.Jobs__Select}>
                    {/* Job location */}
                      <div className={`${OpenJobStyle.Jobs__Location}`}>
                        {/* <Select className={`${OpenJobStyle.Jobs__CustomSelect}`} options={job_locations || []} /> */}
                        <FormikControl
                          className       =     {`${OpenJobStyle.Jobs__Location}`}
                          placeholder     =    {t('label:location')}
                          control         =     "select"
                          default         =     {searching.location_text}
                          formik          =     {formik}
                          disabled        =     {!isPreview}
                          onChange        =     {(value) => showJobAction.handleValueOnChange('location_text', value, searching, searchValues, setPropsData, data, isFrame)}
                          options         =     {locationOptions.options}
                        />
                      </div>
                      {/* End of Job Location */}

                      {/* Job Type Input */}
                    <div className={OpenJobStyle.Jobs__JobType}>
                        {/* <Select className ={`${OpenJobStyle.Jobs__CustomSelect}`} options={job_types || []} /> */}
                        <FormikControl
                          className       =     {`${OpenJobStyle.Jobs__CustomSelect}`}
                          control         =     "select"
                          placeholder     =     {t('label:job_type')}
                          default         =     {searching.job_type}
                          formik          =     {formik}
                          disabled        =     {!isPreview}
                          onChange        =     {(value) => showJobAction.handleValueOnChange( 'job_type', value, searching, searchValues, setPropsData, data, isFrame)}
                          options         =     {jobOptions.options}
                        />
                    </div>
                    {/* End of Job Type Input */}

                      {/* Job Remote */}
                      <div className={`${OpenJobStyle.Jobs__Remote}`}>
                        <FormikControl
                          className       =     {`${OpenJobStyle.Jobs__CustomSelect}`}
                          control         =     "select"
                          // placeholder     =     "Location type"
                          default         =     {remoteOnlyOptions.options[1]}
                          formik          =     {formik}
                          disabled        =     {!isPreview}
                          onChange        =     {(option) => showJobAction.handleValueOnChange('job_location_type', option.value, searching, searchValues, setPropsData, data, isFrame)}
                          options         =     {remoteOnlyOptions.options}
                        />
                      </div>
                      {/* End of Job Remote */}

                    </div>
                </div>
              )}
              </Formik>
          </div>
        </div>

            <div className = {`${OpenJobStyle.Jobs__Listing} ${data.jobs.length > 0 ? 'JustifySpace' : 'JustifyCenter'}`}>
              {data.jobs.length > 0 ? data.jobs.map((job, job_index) => {
                return(
                  <div className={`${OpenJobStyle.Jobs__ListingBox} ${isPublic ? 'CursorPointer' : ''}`} key={`jobs_list_${job_index}`} onClick={()=> {
                      if(isPublic) showJobAction.redirectToJob(job.slug, data.client_slug, isFrame)
                    }} style={customizeCareerAction.setBackgroundColor(formik, page_section.type)}>
                      <h3  className={OpenJobStyle.Jobs__SubTitle} style={labelStyle}>{job.job_title}</h3>
                      <div  className={OpenJobStyle.Jobs__ContractType}>
                        <span className={`tt-captialize`} style={labelStyle}> {customizeCareerAction.contractTypeTranslation(t, job.contract_type)} {job.is_remote && <span style={labelStyle}>, {t('career:jobs:remote')} </span>} {job.is_hybrid && <span style={labelStyle}>, {t('career:jobs:hybrid')} </span>}</span>
                      </div>
                      <div  className={OpenJobStyle.Jobs__PostedLocation}>
                        {job.city_country && job.city_country != ', ' ? <span style={labelStyle}> { job.city_country.split(',')[0]=='' ? job.city_country.split(',')[1].trim() : job.city_country} </span> : <span></span>}
                    {/*     <span className={OpenJobStyle.Jobs__PostDay} style={labelStyle}> */}
                    {/*     {customizeCareerAction.publishedDays(job.published_date)} */}
                    {/* </span> */}
                      </div>

                  </div>
                )
              }) : <p className = {OpenJobStyle.Jobs__NoOpenJobs} style={customizeCareerAction.headerStyle(formik)}>{t('career:jobs:no_jobs')}</p>}
            </div>
            <div className = {`${OpenJobStyle.Jobs__ViewAllJobs}`}>
              {!isPreview && data.jobs.length > 0 && <Button type = "button" style={customizeCareerAction.viewMoreButtonStyle(formik)}>{t('career:jobs:view_more')}</Button>}
              {isPreview && data.next_page && <Button type = "button" style={customizeCareerAction.viewMoreButtonStyle(formik)} onClick={(event) => {
                showJobAction.getData(searching, data, setPropsData, isFrame)
              }}> {t('career:jobs:view_more')}</Button>}
            </div>
        </div>
    </div>
  )
}